import React from "react";
import ReactApexChart from "react-apexcharts";

const ProgressChart = ({ graph }) => {
  const percentValue = graph?.resultData;
  const chartData = {
    series: [percentValue],
    options: {
      chart: { type: "radialBar" },
      plotOptions: {
        radialBar: {
          hollow: { size: "70%" },
        },
      },
      fill: { colors: ["#103C5E"] },
      labels: ["Percent"],
    },
  };

  return (
    <div id="chart" className="p-0">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="radialBar"
        height={200}
      />
      <div className="radiobar__chart__graph text-center pb-3">
        <p>
          <b>{graph?.title}</b> : {graph?.totalData || 0}
        </p>
        <p>
          <b>{graph?.mainTitle}</b> : {graph?.mainData || 0}
        </p>
        <p>
          <b>{graph?.remainingTitle}</b> : {graph?.remainingData || 0}
        </p>
      </div>
    </div>
  );
};

export default ProgressChart;
